import reducer from './router';
import { actionCreators, RouterActionType } from './router.actionCreators';
import * as actionTypes from './router.actionTypes';

export * from './router'; // expose all types
export * from './router.selectors';
export type ActionType = RouterActionType;
export { actionTypes, actionCreators };
export default reducer;
